import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType,
    Widget,
} from '@appblocks/codegeneration/types';
import BaseWidget, { sizes } from '@appblocks/codegeneration/Widgets/BaseWidget';

export default class LineWidget extends BaseWidget {
    constructor() {
        super();
        this.name = 'Line Widget';
        this.id = 'line_widget';
        this.minW = sizes[this.id].minW;
        this.minH = sizes[this.id].minH;

        const settings = this.getWidgetSettings(['VARIABLE', 'LABEL', 'MIN', 'MAX']);

        this.settings = this.settings.concat(settings);
    }
}
